<template>
  <b-modal
    :id="id"
    modal-class="guide-modal"
    size="lg"
    hide-footer
    hide-header
    centered
  >
    <slot> </slot>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["id"]
};
</script>

<style lang="scss" scoped>
.guide-modal___BV_modal_content_ {
  border-radius: 16px;
}
</style>
